module.exports = __webpack_public_path__ + "static/media/24UHCHR17.ff2df761.jpg";